import { render, staticRenderFns } from "./CBProposalReferences.vue?vue&type=template&id=16113a28"
import script from "./CBProposalReferences.vue?vue&type=script&lang=js"
export * from "./CBProposalReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports